<template>
    <header class="APP-header">
        <div class="container-fluid">
          <div class="APP-header-logo"><img class="img-responsive" v-bind:src="`${publicPath}static/img/common/header_logo.png`"></div>
        </div>
    </header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>


<style scoped lang="scss">

</style>
